'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var HTTP = exports.HTTP = 'http error';
var SERVICE = exports.SERVICE = 'services error';


//////////////////
// WEBPACK FOOTER
// ./node_modules/kryfe-lib/es/fetchHelper/consts/exceptionTypes.js
// module id = 04al
// module chunks = 4